import script from "./ProjectBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectBanner.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectBanner.vue?vue&type=style&index=0&id=76607850&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76607850"]])

export default __exports__